import React, { useContext } from "react";
import {
  SheetContent,
  BottomSheet,
  SheetHeader,
  SheetContainer,
  CompareAction,
  CompareItemAction,
  CloseCompare,
  ProductImage,
  ProductAction,
  EmptyProduct,
  ProductItem,
  ProductList,
  ProductCard,
  ProductTitle,
  SheetTitle,
  SheetWarning,
} from "./styles";
import { Context } from "../context";
import PrimaryButton from "../Button/PrimaryButton";
import { CloseIcon } from "../Icons";
import { GatsbyImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
import WhiteButton from "../Button/WhiteButton";
import PrimaryLinkButton from "../Button/PrimaryLinkButton";

const CompareBottomSheet = ({ open, onToggle }) => {
  const {
    compareProducts,
    addProductToComparison,
    removeProduct,
    clearAllComparisonData,
    selectProduct,
  } = useContext(Context);

  const products = [...compareProducts];
  while (products.length < 4) {
    products.push(null);
  }

  return (
    <BottomSheet className={open ? "bottom-sheet-open" : "bottom-sheet-close"}>
      <SheetContainer>
        <SheetHeader>
          <SheetTitle className="h5">
            <span className="text">Compare Products</span>
            <span className="count">({compareProducts.length} of 4)</span>
          </SheetTitle>
          <SheetWarning>
            {!!compareProducts && compareProducts.length === 1 && (
              <span className="warn">Select one more product to compare</span>
            )}
          </SheetWarning>
        </SheetHeader>
        <SheetContent>
          <ProductList>
            {products.map((product, i) =>
              product ? (
                <ProductItem key={i}>
                  <ProductCard>
                    <ProductImage>
                      <GatsbyImage
                        image={product.image.gatsbyImageData}
                        alt={product.title}
                      />
                    </ProductImage>
                    <ProductTitle>{product.title}</ProductTitle>
                    <ProductAction>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => removeProduct(product.id)}
                      >
                        <WhiteButton icon={<CloseIcon />} size="sm" />
                      </button>
                    </ProductAction>
                  </ProductCard>
                </ProductItem>
              ) : (
                <ProductItem key={i}>
                  <EmptyProduct
                    key={i}
                    onClick={async () => {
                      const p = await selectProduct();
                      addProductToComparison("select", p);
                    }}
                  >
                    <span className="icon">+</span>
                    <span className="text">Add Product</span>
                  </EmptyProduct>
                </ProductItem>
              )
            )}
          </ProductList>
          <CompareAction>
            <CompareItemAction
              onClick={() => {
                if (compareProducts.length < 2) {
                  alert("Select one more product to compare");
                  return;
                }
                navigate("/compare");
              }}
            >
              <PrimaryButton text="Compare" size="sm" />
            </CompareItemAction>
            <CompareItemAction onClick={() => clearAllComparisonData()}>
              <PrimaryLinkButton text="Clear all" size="sm" />
            </CompareItemAction>
          </CompareAction>
        </SheetContent>
      </SheetContainer>
      <CloseCompare type="button" onClick={() => onToggle()}><CloseIcon /></CloseCompare>
    </BottomSheet>
  );
};

export default CompareBottomSheet;
